export const environment = {
  production: true,
  apiUrl: 'https://api-equity.moneypluspro.com.br',
  firebaseConfig: {
    apiKey: 'AIzaSyCjzflu72ZQbe-ZmYuhHM5wOWIxNHE9s2M',
    authDomain: 'equityplus-305cc.firebaseapp.com',
    projectId: 'equityplus-305cc',
    storageBucket: 'equityplus-305cc.firebasestorage.app',
    messagingSenderId: '202400321236',
    appId: '1:202400321236:web:fb853c671049b38d3a7541',
    measurementId: 'G-GB1MWYWQYT'
  }
};
